var CourseSearch = { 

    itemsPerPageitemsPerPage: 12,
    searchParams: null,
    renderPartial: null,
    searchUrl: null,
    me: this,

    // Init - Called from the script Utils.AddScript() tag in the template, which also says which
    // search endpoint the page uses, so the same script serves the course and training searches.
    InitCourseSearch : function (_itemsPerPage, _renderPartial, _searchUrl) {
        if (isEmptyOrSpaces(_renderPartial)) {
            alert('Need to pass in the partial name that will render the result');
            return;
        }
        if (isEmptyOrSpaces(_searchUrl)) {
            alert('Need to pass in the url of the search endpoint');
            return;
        }
        this.renderPartial = _renderPartial;
        this.searchUrl = _searchUrl;

        if (_itemsPerPage !== undefined && _itemsPerPage !== null && parseInt(_itemsPerPage) > 0) {
            this.itemsPerPage = parseInt(_itemsPerPage);
        }

        // Repopulate / Recheck the form fields on Init based on query strings
        this.RepopulateFiltersFromUrl();
        
        // Then do initial search, which should get the same results.
        var prom = this.GetSearchResults(1);
        prom.then(
            function (result) {
                $('#search__results').html(result.htmlResults);
                $('#pagination_search').pagination({
                    items: result.totalResultCount,
                    itemsOnPage: this.itemsPerPage,
                    cssStyle: 'light-theme',
                    onPageClick: function (pageNumber, event) {
                        event.preventDefault(); // Prevent the default behaviour of adding the page to the url, which causes headaches with popstate event. 
                        //(May need to revisit this if we want to track pagination in the url but would mean moving the AjaxSearch logic to the popstate event and having to track the pagenumber there based off the hash?)
                        this.DoAjaxSearch(pageNumber, true); // Pagination will not push to history.
                        scrollToAnchorIDOffset('topOfSearch'); ('topOfSearch');
                    }.bind(this),
                    onInit: function () {
                        var resultCount = 0;
                        if (result.totalResultCount !== null) {
                            resultCount = result.totalResultCount;
                        }
                        this.DoPagination(resultCount, 1);
                    }.bind(this)
                });
            }.bind(this)
        );

        // Add events for search box

        $('#siteSearchButtonClear').click(function (event) {
            event.preventDefault();
            this.ClearSiteSearch();
            this.DoAjaxSearch(1);
        }.bind(this));

        $('#searchboxSite').keypress(function (event) {
            var keycode = event.keyCode ? event.keyCode : event.which;
            if (keycode === '13') {
                this.DoAjaxSearch(1);
            }
        }.bind(this));

        document.getElementById("searchboxSite").addEventListener("search", function (event) {
            this.DoAjaxSearch(1);
        }.bind(this));

        $('#siteSearchButtonSearch').click(function (event) {
            event.preventDefault();
            this.DoAjaxSearch(1);
        }.bind(this));

        // Add events for checkboxes
        $('#availability-filter').click(function (event) {
            if ($(this).is(':checked')) {
                $('#availability-filter').val("1");
                document.getElementById('hsb-avail').value = 1;
                this.DoAjaxSearch(1);
            }
            else {
                $('#availability-filter').val("0");
                document.getElementById('hsb-avail').value = 0;
                this.DoAjaxSearch(1);
            }
        }.bind(this));

        $(".search__aggregation input[type='checkbox']").click(function (event) {
            //Get the input ID and update the corresponding hidden input value:
            var inputId = event.target.id;
            var inputNm = event.target.name;

            if (inputId !== "availability-filter") {
                //The hidden input is one of the following: hsb-subject / hsb-mode / hsb-campus / hsb-level
                var hiddenInput = document.getElementById('hsb-' + inputId.split('checkbox_')[0]);
                var hiddenInputValues = hiddenInput.value ? hiddenInput.value.split(',') : [];
                if ($(event.target).is(':checked')) {
                    if (!hiddenInputValues.includes(inputNm)) {
                        hiddenInputValues.push(inputNm);
                    }
                } else {
                    hiddenInputValues = hiddenInputValues.filter(function (value) {
                        return value !== inputNm;
                    });
                }

                hiddenInput.value = hiddenInputValues.join(',');
                this.DoAjaxSearch(1);
            }
        }.bind(this));

        // Filter expand mobile
        var filterTrigger = $('.search__filter-button');
        var filters = $('.search__filters');
    
        filterTrigger.click(function () {
            if (filters.is(':visible')) {
                filters.slideUp();
            } else {
                filters.css('display', 'flex').hide().slideDown();
            }
        }.bind(this));

        // Listen for the popstate event to handle browser navigation
        window.addEventListener('popstate', function () {
            this.ClearSiteSearch(); // Clear filters...
            this.RepopulateFiltersFromUrl(); // Repopulate filters...
            this.DoAjaxSearch(1, true); // Get the results as they were when pushed to history
        }.bind(this));
    },

    RepopulateFiltersFromUrl: function () {
        var urlParams = new URLSearchParams(window.location.search);

        if (urlParams.has('query')) {
            $('#searchboxSite').val(urlParams.get('query'));
        }
        if (urlParams.has('subject')) {
            var subjects = urlParams.get('subject').split(',');
            subjects.forEach(function (subject) {
                $("input[name='" + subject + "'][id^='subjectcheckbox_']").prop('checked', true);
                document.getElementById('hsb-subject').value = subjects.join(',');
            });
        }
        if (urlParams.has('mode')) {
            var modes = urlParams.get('mode').split(',');
            modes.forEach(function (mode) {
                $("input[name='" + mode + "'][id^='modecheckbox_']").prop('checked', true);
                document.getElementById('hsb-mode').value = modes.join(',');
            });
        }
        if (urlParams.has('campus')) {
            var campuses = urlParams.get('campus').split(',');
            campuses.forEach(function (campus) {
                $("input[name='" + campus + "'][id^='campuscheckbox_']").prop('checked', true);
                document.getElementById('hsb-campus').value = campuses.join(',');
            });
        }
        if (urlParams.has('level')) {
            var levels = urlParams.get('level').split(',');
            levels.forEach(function (level) {
                $("input[name='" + level + "'][id^='levelcheckbox_']").prop('checked', true);
                document.getElementById('hsb-level').value = levels.join(',');
            });
        }
        if (urlParams.has('available') && urlParams.get('available') === '1') {
            $('#availability-filter').prop('checked', true);
            document.getElementById('hsb-avail').value = 1;
        } else {
            $('#availability-filter').prop('checked', false);
            document.getElementById('hsb-avail').value = 0;
        }
    },

    ClearSiteSearch : function () {
        // Clear all the filters
        $('.search__aggregation input[type=checkbox]').prop('checked', false);
        $('.search__aggregation .search__aggregation-icon').removeClass('search__aggregation-icon--active');
        // Clear hidden input fields associated with checkboxes
        $('#hsb-subject').val('');
        $('#hsb-mode').val('');
        $('#hsb-campus').val('');
        $('#hsb-level').val('');
        $('#hsb-avail').val('');
        $('#searchboxSite').val(''); // This too
    },

    DoPagination : function (resultCount, currentPage) {
        var $pagination = $('#pagination_search');

        console.log('Page results count : %o - Per page : %o', resultCount, this.itemsPerPage);

        if (resultCount !== null && resultCount > this.itemsPerPage) {
            $pagination.pagination('destroy');
            $pagination.pagination('updateItems', resultCount);
            $pagination.pagination('drawPage', currentPage);
            $pagination.show();
        } else {
            $pagination.hide();
        }
    },

    DoAjaxSearch: function (pageNo, NoTrack) {
        // Update url params
        var searchBox = $('#searchboxSite').val();
        var subjectArea = [];
        var studyMode = [];
        var studyLocation = [];
        var scqfLevel = [];
        var availability = $('#availability-filter').is(':checked') ? "1" : "0";

        $("input[id^='subjectcheckbox_']:checked").each(function () {
            subjectArea.push($(this).attr('name'));
        });

        $("input[id^='modecheckbox_']:checked").each(function () {
            studyMode.push($(this).attr('name'));
        });

        $("input[id^='campuscheckbox_']:checked").each(function () {
            studyLocation.push($(this).attr('name'));
        });

        $("input[id^='levelcheckbox_']:checked").each(function () {
            scqfLevel.push($(this).attr('name'));
        });
        if (NoTrack) {
            // Do not update url params
        } else {
            this.UpdateParams(searchBox, subjectArea, studyMode, studyLocation, scqfLevel, availability);
        }

        var prom = this.GetSearchResults(pageNo);
        prom.then(
            function (result) {
                console.log("Processing ajax results : %o", result);
                $('#search__results').html(result.htmlResults);
                this.DoPagination(result.totalResultCount, pageNo);
            }.bind(this)
        );
    },

    // Do our ajax call to fetch the results
    GetSearchResults : function (pageNo) {
        return new Promise(function (resolve, reject) {
            var paramSource = "";
            paramSource = "fields";
            searchParams = this.BuildSiteSearchParams(pageNo);

            console.log('GetSearchResults with %o searchParams : %o', paramSource, searchParams);

            fetch(this.searchUrl, {
                body: JSON.stringify(searchParams), method: 'post', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            })
            .then(function (response) {
                resolve(response.json());
            })
            .catch(error => {
                console.log('Failed', error);
                reject(error);
            });
        }.bind(this));
    },

    BuildSiteSearchParams: function (pageNo) {
        searchParams = {};
        searchParams.currentResultPage = pageNo;
        searchParams.partialView = this.renderPartial;

        // Query
        if ($('#searchboxSite').val() !== '') {
            searchParams.keywords = $('#searchboxSite').val();
        }

        // Subjects (collect checked subjects)
        searchParams.subjects = [];
        $("input[id^='subjectcheckbox_']:checked").each(function () {
            searchParams.subjects.push($(this).attr('name'));
        });

        // Modes (collect checked modes)
        searchParams.modes = [];
        $("input[id^='modecheckbox_']:checked").each(function () {
            searchParams.modes.push($(this).attr('name'));
        });

        // Campuses (collect checked campuses)
        searchParams.campuses = [];
        $("input[id^='campuscheckbox_']:checked").each(function () {
            searchParams.campuses.push($(this).attr('name'));
        });

        // Levels (collect checked levels)
        searchParams.levels = [];
        $("input[id^='levelcheckbox_']:checked").each(function () {
            searchParams.levels.push($(this).attr('name'));
        });

        // Availability filter (checkbox for available courses only)
        if ($('#availability-filter').is(':checked')) {
            searchParams.available = true;
        }

        searchParams.resultsPerPage = this.itemsPerPage;
        return searchParams;
    },

    UpdateParams: function (searchBox, subjectArea, studyMode, studyLocation, scqfLevel, availability)
    {
        var url = new URL(window.location);
        url.searchParams.set("query", searchBox);
        url.searchParams.set("subject", subjectArea.join(','));
        url.searchParams.set("mode", studyMode.join(','));
        url.searchParams.set("campus", studyLocation.join(','));
        url.searchParams.set("level", scqfLevel.join(','));
        url.searchParams.set("available", availability);
        console.log('UpdateParam');
        history.pushState(null, '', url);
    }
}